var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBglSimpleInvest360(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003EA5",
    d: "M4.686 4.685a15.905 15.905 0 0 1 8.82-4.49 15.982 15.982 0 0 1 12.331 3.182s-4.738 4.734-4.79 4.791a7.48 7.48 0 0 0-1.06 1.527 7.44 7.44 0 0 0-.822 4.036c.015.195.056.391.084.585.05.343.14.672.211 1.01a3.52 3.52 0 0 1-.968 3.165 3.49 3.49 0 0 1-1.28.816c-.175.066-.691.17-.76.185a1.98 1.98 0 0 0 .376 3.916c.233-.015.464-.052.69-.109a7.472 7.472 0 0 0 5.097-3.85 7.475 7.475 0 0 0 .62-5.26 3.898 3.898 0 0 1-.11-1.613c.07-.438.222-.86.45-1.24.277-.402.601-.769.966-1.092l.937-.937 1.089-1.089 1.029-1.029.755-.755.27-.27a15.971 15.971 0 0 1 3.186 12.319s-.006.006 0 .01c-.118.76-.292 1.51-.52 2.245A16.003 16.003 0 0 1 6.166 28.62l4.357-4.359c.029-.023.32-.323.327-.334l.009-.008a7.343 7.343 0 0 0 1.149-1.622 7.528 7.528 0 0 0 .68-5.05 5.807 5.807 0 0 1-.197-1.513c.03-.51.178-1.005.43-1.448.158-.286.356-.548.587-.778.3-.299.654-.537 1.044-.704.4-.135.809-.242 1.224-.32A1.98 1.98 0 0 0 15.07 8.6l-.195.028a7.472 7.472 0 0 0-5.483 3.91 7.47 7.47 0 0 0-.645 5.198 4.19 4.19 0 0 1 .138 1.621 3.496 3.496 0 0 1-.854 1.824l-4.653 4.654A16.014 16.014 0 0 1 .197 13.498a15.916 15.916 0 0 1 4.49-8.813"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBglSimpleInvest360);
export default __webpack_public_path__ + "static/media/bglSimpleInvest360.c308a4b51f7d72ae43d7de6a1642891d.svg";
export { ForwardRef as ReactComponent };